﻿'use strict';

angular.module('ntmApp').factory('SharedRecurrence', ['Recurrence', 'Constants', function (Recurrence, Constants) {

    function SharedRecurrence() {
        Recurrence.call(this);

        var self = this;

        self.displaySchedulingLeeway = function () {
            return false;
        };

        self.displayOccurenceLimit = function () {
            return false;
        };

        self.displaySchedulingSettings = function () {
            return 'ng1/src/setup/recurrence/templates/shared-scheduling-settings.html';
        };

        self.hideStartsOnDateBasedOnConditions = function () {
            return false;
        };

        self.getFieldsListForSave = function () {
            var fieldsList = self.getGeneralFieldsListForSave();

            fieldsList.startsOnDate = self.startsOnDate;

            fieldsList.sharedPatternItems = self.sharedOption;

            if ((fieldsList.startsOnDate && fieldsList.startsOnDate.value) && (fieldsList.occurenceLimitEndsOnDate && fieldsList.occurenceLimitEndsOnDate.value)) {
                fieldsList.dateStartAndDateEnd = [{ dateStart: self.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
            }

            return fieldsList;
        };

        self.getRequestData = function () {

            var request = self.getGeneralRequestData();

            request.dateStart = self.startsOnDate.value;
            request.selectedSharedItem = self.sharedOption.value;

            return request;
        };

        self.applyDefaultInfo = function (data) {
            self.applyGeneralDefaultInfo(data);
            self.sharedOptions = data.sharedPatternItems;
        };

        self.checkForDynamicRestricts = function (field, fieldName) {

            switch (fieldName) {
                case 'startsOnDate':
                    field.restricts.allowNullable = true;

                    break;
                default:
                    break;
            }
        };

        self.equals = function (recurrence) {

            if (!self.compareGeneralInfo(recurrence)) {
                return false;
            }

            if (self.sharedOption.value !== recurrence.sharedOption.value) {
                return false;
            }

            return true;
        };

        function initialize() {
            self.patternType = Constants.Recurrence.Patterns.SHARED.value;
        }

        initialize();
    }

    SharedRecurrence.prototype = Object.create(Recurrence.prototype);
    SharedRecurrence.prototype.constructor = Recurrence;

    return (SharedRecurrence);

}]);